import { Button, Col, Row, Table } from 'react-bootstrap'
import { FaEdit, FaTrash } from 'react-icons/fa'

const MenuCostTable = ({
    costItems,
    subRecipeItems,
    handleEdit,
    handleDelete,
    handleSave,
    formData,
    profitPercentage,
    handleSubRecipeDelete,
    handleSubRecipeEdit,
    manualTotalCost,
    setManualTotalCost,
    setFormData
}) => {

    const handleSellingPriceChange = (e) => {
        const newPrice = e.target.value;
        setFormData(prev => ({
            ...prev,
            sellingPrice: newPrice
        }));
    };

    return (
        <>
            {(costItems.length > 0 || subRecipeItems.length > 0) && (
                <div className="mb-3">
                    {costItems.length > 0 && (
                        <>
                            <h3 className="text-lg font-semibold mb-3">Ingredients</h3>
                            <Table striped bordered hover className="text-center mb-5">
                                <thead>
                                    <tr>
                                        <th>Ingredients</th>
                                        <th>Rate</th>
                                        <th>Unit</th>
                                        <th>UOM</th>
                                        <th>Quantity</th>
                                        <th>Cost</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {costItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.costItem}</td>
                                            <td>{item.rate}</td>
                                            <td>{item.unit} ({item.uom})</td>
                                            <td>{item.new_uom}</td>
                                            <td>{item.quantity}</td>
                                            <td>{item.costPrice}</td>
                                            <td>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => handleEdit(index)}
                                                    className="mr-2"
                                                >
                                                    <FaEdit />
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(index)}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}

                    {subRecipeItems.length > 0 && (
                        <>
                            <h3 className="text-lg font-semibold mb-3">Sub-Recipes</h3>
                            <Table striped bordered hover className="text-center mb-5">
                                <thead>
                                    <tr>
                                        <th>Sub Recipe</th>
                                        <th>Rate</th>
                                        <th>Unit</th>
                                        <th>UOM</th>
                                        <th>Quantity</th>
                                        <th>Cost</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subRecipeItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.subRecipeName}</td>
                                            <td>{item.rate}</td>
                                            <td>{item.unit} ({item.uom})</td>
                                            <td>{item.new_uom}</td>
                                            <td>{item.quantity}</td>
                                            <td>{item.costprice}</td>
                                            <td>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => handleSubRecipeEdit(index)}
                                                    className="mr-2"
                                                >
                                                    <FaEdit />
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleSubRecipeDelete(index)}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    )}

                </div>
            )}

            <div className="bg-gray-100 p-4 rounded-lg mb-6">
                <Row>
                    <Col md={4}>
                        <div className="font-bold flex gap-3 items-center">
                            <label>Total Cost :</label>
                            <input
                                type="number"
                                value={manualTotalCost}
                                onChange={(e) => setManualTotalCost(e.target.value)}
                                className="border p-2 rounded w-32 font-semibold text-center"
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="font-bold flex gap-3 items-center">
                            <label>Selling Price :</label>
                            <input
                                type="number"
                                value={formData.sellingPrice}
                                onChange={handleSellingPriceChange}
                                className="border p-2 rounded w-32 font-semibold text-center"
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="font-bold flex gap-3 items-center">
                            <label>Cost Percentage :</label>
                            <input
                                type="text"
                                value={`${profitPercentage} %`}
                                readOnly
                                className="border p-2 rounded w-32 font-semibold text-center"
                            />
                        </div>
                    </Col>
                </Row>
            </div>

            <Button variant="success" onClick={handleSave} className='mb-2'>
                <div className='flex justify-center items-center gap-2'>
                    Save Cost
                </div>
            </Button>
        </>
    )
}

export default MenuCostTable